import { Button, CircularProgress, DialogActions, Dialog, DialogTitle, DialogContent, TextField } from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import { useContext, useState, useEffect } from "react";
import { DataUser } from "../../context/DataUser";

const Modaladdcreditsdescriptions = ({ open, setOpen }) => {
  const { updateDescriptionsByProject } = useContext(DataUser);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  const [selectedProjects, setSelectedProjects] = useState([]);
 // console.log("selectedProjects",selectedProjects);
  const [initialSegments, setInitialSegments] = useState(0);
  const [finalSegments, setFinalSegments] = useState(0);
  const [segmentFields, setSegmentFields] = useState({});
 // console.log("segmentFields",segmentFields);
  const [segmentData, setSegmentData] = useState([]);
 // console.log("segmentData",segmentData);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const { user } = useContext(DataUser);

  useEffect(() => {
    if (open && user) {
      fetchProjects();
    }
  }, [open, user]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_URL}/api/projects/pm/${user.uid}?role=AD`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.status) {
        setProjects(data.projects);
      }
    } catch (error) {
      //console.error("Error fetching projects:", error);
      setToastMessage("Error fetching projects");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleProjectSelect = (projectId) => {
    setSelectedProjects((prev) => {
      if (prev.includes(projectId)) {
        return prev.filter((id) => id !== projectId);
      } else {
        return [...prev, projectId];
      }
    });
  };

  const handleSegmentNumberChange = (type, value) => {
    const numValue = parseInt(value) || 0;
    if (type === 'initial') {
      setInitialSegments(numValue);
    } else {
      setFinalSegments(numValue);
    }
    
    // Crear campos separados para segmentos iniciales y finales
    const newFields = {
      initial: Array.from({ length: type === 'initial' ? numValue : initialSegments }, (_, index) => ({
        id: index + 1,
        value: '',
        type: 'initial'
      })),
      final: Array.from({ length: type === 'final' ? numValue : finalSegments }, (_, index) => ({
        id: index + 1,
        value: '',
        type: 'final'
      }))
    };
    
    setSegmentFields({...newFields});
    setSegmentData([...newFields.initial, ...newFields.final]);
  };

  const handleSegmentFieldChange = (type, index, value) => {
    const newSegmentFields = { ...segmentFields };
    newSegmentFields[type][index] = {
      ...newSegmentFields[type][index],
      value: value
    };
    setSegmentFields(newSegmentFields);
    setSegmentData([...newSegmentFields.initial, ...newSegmentFields.final]);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProjects([]);
    setInitialSegments(0);
    setFinalSegments(0);
    setSegmentFields({});
    setSegmentData([]);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const result = await updateDescriptionsByProject(selectedProjects, segmentData);
      
      if (result.error) {
        setToastMessage(result.error);
        setToastSeverity("error");
      } else {
        setToastMessage("Descriptions updated successfully");
        setToastSeverity("success");
        setOpenConfirmModal(false);
        handleClose();
      }
    } catch (error) {
      console.error("Error updating descriptions:", error);
      setToastMessage("Error updating descriptions");
      setToastSeverity("error");
    } finally {
      setLoading(false);
      setOpenToast(true);
    }
  };

  return (
    <>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toastSeverity}>{toastMessage}</Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#28262E",
            color: "white"
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "white", backgroundColor: "#28262E" }}
        >
          Add Credits Descriptions
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#28262E", padding: 3 }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div style={{ width: "100%", marginBottom: "20px" }}>
                <h3>Select Projects</h3>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {projects.map((project) => (
                    <Button
                      key={project._id}
                      variant={selectedProjects.includes(project._id) ? "contained" : "outlined"}
                      onClick={() => handleProjectSelect(project._id)}
                      sx={{ color: "white", borderColor: "white" }}
                    >
                      {project.name}
                    </Button>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: "20px" }}>
                <TextField
                  label="Initial Segments"
                  type="number"
                  value={initialSegments}
                  onChange={(e) => handleSegmentNumberChange('initial', e.target.value)}
                  sx={{ 
                    marginRight: 2,
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiInputLabel-root': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'white' },
                      '&:hover fieldset': { borderColor: 'white' },
                      '&.Mui-focused fieldset': { borderColor: 'white' }
                    }
                  }}
                />
                <TextField
                  label="Final Segments"
                  type="number"
                  value={finalSegments}
                  onChange={(e) => handleSegmentNumberChange('final', e.target.value)}
                  sx={{ 
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiInputLabel-root': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'white' },
                      '&:hover fieldset': { borderColor: 'white' },
                      '&.Mui-focused fieldset': { borderColor: 'white' }
                    }
                  }}
                />
              </div>

              {(segmentFields.initial?.length > 0 || segmentFields.final?.length > 0) && (
                <div style={{ marginTop: "20px" }}>
                  <h3>Segments Descriptions</h3>
                  
                  <div style={{ 
                    display: 'flex',
                    flexDirection: segmentFields.initial?.length > 0 && segmentFields.final?.length > 0 ? 'row' : 'column',
                    gap: '20px'
                  }}>
                    {/* Segmentos Iniciales */}
                    {segmentFields.initial?.length > 0 && (
                      <div style={{ 
                        flex: segmentFields.final?.length > 0 ? 1 : 'auto',
                        padding: "15px",
                        borderRadius: "8px",
                        backgroundColor: "rgba(255, 255, 255, 0.05)"
                      }}>
                        <h4 style={{ marginBottom: "15px", color: "#8EC36A" }}>Initial Segments</h4>
                        {segmentFields.initial.map((field, index) => (
                          <TextField
                            key={`initial-${field.id}`}
                            label={`Initial Segment ${field.id}`}
                            value={field.value}
                            onChange={(e) => handleSegmentFieldChange('initial', index, e.target.value)}
                            fullWidth
                            sx={{ 
                              marginBottom: 2,
                              '& .MuiInputBase-input': { color: 'white' },
                              '& .MuiInputLabel-root': { color: '#8EC36A' },
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#8EC36A' },
                                '&:hover fieldset': { borderColor: '#8EC36A' },
                                '&.Mui-focused fieldset': { borderColor: '#8EC36A' }
                              }
                            }}
                          />
                        ))}
                      </div>
                    )}

                    {/* Segmentos Finales */}
                    {segmentFields.final?.length > 0 && (
                      <div style={{ 
                        flex: segmentFields.initial?.length > 0 ? 1 : 'auto',
                        padding: "15px",
                        borderRadius: "8px",
                        backgroundColor: "rgba(255, 255, 255, 0.05)"
                      }}>
                        <h4 style={{ marginBottom: "15px", color: "#952937" }}>Final Segments</h4>
                        {segmentFields.final.map((field, index) => (
                          <TextField
                            key={`final-${field.id}`}
                            label={`Final Segment ${field.id}`}
                            value={field.value}
                            onChange={(e) => handleSegmentFieldChange('final', index, e.target.value)}
                            fullWidth
                            sx={{ 
                              marginBottom: 2,
                              '& .MuiInputBase-input': { color: 'white' },
                              '& .MuiInputLabel-root': { color: '#952937' },
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#952937' },
                                '&:hover fieldset': { borderColor: '#952937' },
                                '&.Mui-focused fieldset': { borderColor: '#952937' }
                              }
                            }}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "#28262E",
            padding: 3,
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <Button
            onClick={handleClose}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => setOpenConfirmModal(true)}
            sx={{ 
              color: "white", 
              backgroundColor: "#8EC36A",
              '&:hover': {
                backgroundColor: '#7ab358'
              }
            }}
            disabled={loading || selectedProjects.length === 0 || segmentData.length === 0}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        aria-labelledby="confirm-dialog-title"
        PaperProps={{
          sx: {
            backgroundColor: "#28262E",
            color: "white"
          }
        }}
      >
        <DialogTitle id="confirm-dialog-title" sx={{ color: "white" }}>
          Confirm Update Descriptions
        </DialogTitle>
        <DialogContent sx={{ color: "white", pt: 2 }}>
          <div style={{ marginBottom: '15px' }}>
            The descriptions will be updated in the following projects. Are you sure you want to proceed?
          </div>
          <div style={{ 
            backgroundColor: 'rgba(255,255,255,0.1)', 
            padding: '10px', 
            borderRadius: '4px',
            fontSize: '0.9em' 
          }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>Selected Projects:</strong> {selectedProjects.length} projects
            </div>
            <div>
              <strong>Total Segments:</strong> {segmentData.length} segments
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#28262E", padding: 2 }}>
          <Button
            onClick={() => setOpenConfirmModal(false)}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            sx={{ 
              color: "white", 
              backgroundColor: "#8EC36A",
              '&:hover': {
                backgroundColor: '#7ab358'
              }
            }}
            disabled={loading}
          >
            Confirm Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Modaladdcreditsdescriptions;